import { render } from "./MixedChart.vue?vue&type=template&id=24a8e595"
import script from "./MixedChart.vue?vue&type=script&lang=js"
export * from "./MixedChart.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\takht-jamshid\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__